export const SIGNUP = 'SIGNUP';
export const OPEN_SIGNUPBOX = 'OPEN_SIGNUPBOX';
export const CLOSE_SIGNUPBOX = 'CLOSE_SIGNUPBOX';
export const OPEN_CONFIRMATIONBOX = 'OPEN_CONFIRMATIONBOX';
export const CLOSE_CONFIRMATIONBOX = 'CLOSE_CONFIRMATIONBOX';
export const SIGNOUT = 'SIGNOUT';
export const SIGNIN = 'SIGNIN';
export const COURSES = 'COURSES';
export const CURRENT_SECTION = 'CURRENT_SECTION';
export const CHANGE_PLAYSTATUS = 'CHANGE_PLAYSTATUS';
export const CURRENT_PROGRESS = 'CURRENT_PROGRESS';
export const PLAYER = 'PLAYER';
export const PLAYLIST = 'PLAYLIST';
export const ADDTOCART = 'ADDTOCART';
export const DELETE_FROM_CART = 'DELETE_FROM_CART';
export const DELETE_ALL = 'DELETE_ALL';
export const USER_COURSES = 'USER_COURSES';
export const OPEN_REVIEWBOX = 'OPEN_REVIEWBOX';
export const CLOSE_REVIEWBOX = 'CLOSE_REVIEWBOX';
export const CURRENT_COURSE = 'CURRENT_COURSE';
export const CHANGE_SPEED = 'CHANGE_SPEED';
export const SUBSCRIBE_TO_CATEGORIES = 'SUBSCRIBE_TO_CATEGORIES';
export const ADD_MANAGED_SOUNDCASTS = 'ADD_MANAGED_SOUNDCASTS';
export const EDIT_MANAGED_SOUNDCAST = 'EDIT_MANAGED_SOUNDCAST';
export const ADD_SUBSCRIPTIONS = 'ADD_SUBSCRIPTIONS';
export const EDIT_SUBSCRIPTION = 'EDIT_SUBSCRIPTION';
export const ADD_EPISODES = 'ADD_EPISODES';
export const EDIT_EPISODE = 'EDIT_EPISODE';
export const EMAIL_SENT = 'EMAIL_SENT';
export const CONTENT_SAVED = 'CONTENT_SAVED';
export const DEFAULT_SOUNDCAST_ADDED = 'DEFAULT_SOUNDCAST_ADDED';
export const FEED_VERIFIED = 'FEED_VERIFIED';
export const CHARGE_STATE = 'CHARGE_STATE';

// v2 actions types

// User
export const OPEN_LIVE_CHANNELS = 'OPEN_LIVE_CHANNELS';
export const CLOSE_LIVE_CHANNELS = 'CLOSE_LIVE_CHANNELS';
export const OPEN_USER_CHANNEL = 'OPEN_USER_CHANNEL';
export const CLOSE_USER_CHANNEL = 'CLOSE_USER_CHANNEL';
export const UPDATE_USER = 'UPDATE_USER';
export const OPEN_USER_MANAGED_CHANNEL = 'OPEN_USER_MANAGED_CHANNEL';
export const CLOSE_USER_MANAGED_CHANNEL = 'CLOSE_USER_MANAGED_CHANNEL';
export const UPDATE_USER_MANAGED = 'UPDATE_USER_MANAGED';

// Publisher
export const OPEN_PUBLISHER_CHANNEL = 'OPEN_PUBLISHER_CHANNEL';
export const CLOSE_PUBLISHER_CHANNEL = 'CLOSE_PUBLISHER_CHANNEL';
export const UPDATE_PUBLISHER = 'UPDATE_PUBLISHER';
export const FETCH_PUBLISHER_PLAN_USAGE = 'FETCH_PUBLISHER_PLAN_USAGE';

// Managed soundcast
export const CLOSE_SOUNDCAST_CHANNEL = 'CLOSE_SOUNDCAST_CHANNEL';
export const OPEN_SOUNDCAST_CHANNEL = 'OPEN_SOUNDCAST_CHANNEL';
export const SELECT_SOUNDCAST = 'SELECT_SOUNDCAST';
export const RECEIVE_MANAGED_SOUNDCASTS = 'RECEIVE_MANAGED_SOUNDCASTS';
export const UPDATE_MANAGED_SOUNDCAST = 'UPDATE_MANAGED_SOUNDCAST';
export const MANAGED_SOUNDCASTS_STATUS = 'MANAGED_SOUNDCASTS_STATUS';
export const INCREASE_PLAN_CURRENT_USAGE = 'INCREASE_PLAN_CURRENT_USAGE';
export const DECREASE_PLAN_CURRENT_USAGE = 'DECREASE_PLAN_CURRENT_USAGE';
export const REMOVE_SOUNDCAST_PENDING_INVITES = 'REMOVE_SOUNDCAST_PENDING_INVITES';

// Dashboard ordered soundcasts
export const FETCH_MANAGED_SOUNDCASTS_ORDER = 'FETCH_MANAGED_SOUNDCASTS_ORDER';
export const CHANGE_SOUNDCASTS_ORDER = 'CHANGE_SOUNDCASTS_ORDER';
export const UPDATE_SOUNDCASTS_ORDER = 'UPDATE_SOUNDCASTS_ORDER';
// Dashboard ordered bundles
export const FETCH_MANAGED_BUNDLES_ORDER = 'FETCH_MANAGED_BUNDLES_ORDER';
export const CHANGE_BUNDLES_ORDER = 'CHANGE_BUNDLES_ORDER';
export const UPDATE_BUNDLES_ORDER = 'UPDATE_BUNDLES_ORDER';
// Dashboard ordered soundcasts in bundle
export const FETCH_BUNDLE_SOUNDCASTS_ORDER = 'FETCH_BUNDLE_SOUNDCASTS_ORDER';
export const CHANGE_BUNDLE_SOUNDCASTS_ORDER = 'CHANGE_BUNDLE_SOUNDCASTS_ORDER';
export const UPDATE_BUNDLE_SOUNDCASTS_ORDER = 'UPDATE_BUNDLE_SOUNDCASTS_ORDER';

// Managed episode
export const FETCH_MANAGED_SOUNDCAST_EPISODES = 'FETCH_MANAGED_SOUNDCAST_EPISODES';
export const RECEIVE_MANAGED_SOUNDCAST_EPISODES = 'RECEIVE_MANAGED_SOUNDCAST_EPISODES';
export const UPDATE_SOUNDCAST_EPISODES_ORDER = 'UPDATE_SOUNDCAST_EPISODES_ORDER';
export const ADD_UPDATE_MANAGED_SOUNDCAST_EPISODE = 'ADD_UPDATE_MANAGED_SOUNDCAST_EPISODE';
export const DELETE_MANAGED_SOUNDCAST_EPISODES = 'DELETE_MANAGED_SOUNDCAST_EPISODES';
export const BULK_ACTION_EPISODES = 'BULK_ACTION_EPISODES';

// ratings
export const FETCH_MANAGED_SOUNDCAST_RATINGS_LIST = 'FETCH_MANAGED_SOUNDCAST_RATINGS_LIST';
export const FETCH_MANAGED_SOUNDCAST_RATINGS_OVERVIEW = 'FETCH_MANAGED_SOUNDCAST_RATINGS_OVERVIEW';
export const DELETE_MANAGED_SOUNDCAST_RATINGS = 'DELETE_MANAGED_SOUNDCAST_RATINGS';

// Categories
export const CREATE_PUBLISHER_CATEGORY = 'CREATE_PUBLISHER_CATEGORY';
export const CREATE_PUBLISHER_CATEGORY_SUCCESS = 'CREATE_PUBLISHER_CATEGORY/SUCCESS';
export const CREATE_PUBLISHER_CATEGORY_FAIL = 'CREATE_PUBLISHER_CATEGORY/FAIL';
export const FETCH_PUBLISHER_CATEGORIES = 'FETCH_PUBLISHER_CATEGORIES';
export const LOAD_PUBLISHER_CATEGORIES = 'LOAD_PUBLISHER_CATEGORIES';
export const LOAD_SOUNDCASTS_PUBLISHER_CATEGORIES = 'LOAD_SOUNDCASTS_PUBLISHER_CATEGORIES';
export const FETCH_PUBLISHER_CATEGORY_INFO = 'FETCH_PUBLISHER_CATEGORY_INFO';
export const LOAD_PUBLISHER_CATEGORY_INFO = 'LOAD_PUBLISHER_CATEGORY_INFO';
export const UPDATE_SOUNDCAST_PUBLISHER_CATEGORY = 'UPDATE_SOUNDCAST_PUBLISHER_CATEGORY';
export const UPDATE_SOUNDCAST_PUBLISHER_CATEGORY_SUCCESS = 'UPDATE_SOUNDCAST_PUBLISHER_CATEGORY/SUCCESS';
export const UPDATE_SOUNDCAST_PUBLISHER_CATEGORY_FAIL = 'UPDATE_SOUNDCAST_PUBLISHER_CATEGORY/FAIL';
export const UPDATE_SOUNDCAST_PUBLISHER_CATEGORY_TITLE = 'UPDATE_SOUNDCAST_PUBLISHER_CATEGORY_TITLE';
export const UPDATE_SOUNDCAST_PUBLISHER_CATEGORY_TITLE_SUCCESS = 'UPDATE_SOUNDCAST_PUBLISHER_CATEGORY_TITLE/SUCCESS';
export const UPDATE_SOUNDCAST_PUBLISHER_CATEGORY_TITLE_FAIL = 'UPDATE_SOUNDCAST_PUBLISHER_CATEGORY_TITLE/FAIL';
export const UPDATE_PUBLISHER_CATEGORIES_ORDER = 'UPDATE_PUBLISHER_CATEGORIES_ORDER';
export const DELETE_PUBLISHER_CATEGORY = 'DELETE_PUBLISHER_CATEGORY';
export const UPDATE_FEATURED_CATEGORY = 'UPDATE_FEATURED_CATEGORY';
export const CLEAR_FEATURED_CATEGORY = 'CLEAR_FEATURED_CATEGORY';
